import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "tab-pane fade",
  id: "offers",
  role: "tabpanel"
}
const _hoisted_2 = { class: "card mt-5 mb-xl-10" }
const _hoisted_3 = { class: "card-body" }
const _hoisted_4 = {
  class: "accordion",
  id: "kt_accordion"
}
const _hoisted_5 = ["id"]
const _hoisted_6 = ["data-bs-target", "aria-controls"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "fs-5 mx-5" }
const _hoisted_9 = { class: "fs-5 badge badge-light-primary" }
const _hoisted_10 = ["id", "aria-labelledby"]
const _hoisted_11 = { class: "accordion-body" }
const _hoisted_12 = {
  key: 0,
  class: "row mb-4"
}
const _hoisted_13 = { class: "col-12" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "row" }
const _hoisted_16 = { class: "col-3" }
const _hoisted_17 = { class: "fw-bold mt-5" }
const _hoisted_18 = { class: "col-3" }
const _hoisted_19 = { class: "fw-bold mt-5" }
const _hoisted_20 = { class: "col-3" }
const _hoisted_21 = { class: "fw-bold mt-5" }
const _hoisted_22 = { class: "col-2" }
const _hoisted_23 = {
  key: 0,
  class: "fw-bold mt-5 badge-light-success fs-4"
}
const _hoisted_24 = {
  key: 0,
  class: "col-1"
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "card-header" }, [
        _createElementVNode("h3", { class: "card-title" }, "Offers")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoice.InvoiceDiscountOffers, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "accordion-item",
              key: index
            }, [
              _createElementVNode("h2", {
                class: "accordion-header",
                id: 'kt_accordion_'+index+'_header_'+index
              }, [
                _createElementVNode("button", {
                  class: "accordion-button fw-bold collapsed",
                  type: "button",
                  "aria-expanded": "false",
                  "data-bs-toggle": "collapse",
                  "data-bs-target": '#kt_accordion_'+index+'_body_'+index,
                  "aria-controls": 'kt_accordion_'+index+'_body_'+index
                }, [
                  _createElementVNode("span", {
                    class: "me-5",
                    innerHTML: _ctx.getDiscountOfferStatusLabel(item.Status)
                  }, null, 8, _hoisted_7),
                  _createElementVNode("span", _hoisted_8, [
                    _cache[0] || (_cache[0] = _createTextVNode("Offer created date: ", -1)),
                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.dateTimeFormat(item.Created)), 1)
                  ])
                ], 8, _hoisted_6)
              ], 8, _hoisted_5),
              _createElementVNode("div", {
                id: 'kt_accordion_'+index+'_body_'+index,
                class: "accordion-collapse collapse",
                "aria-labelledby": 'kt_accordion_'+index+'_header_'+index,
                "data-bs-parent": '#kt_accordion'
              }, [
                _createElementVNode("div", _hoisted_11, [
                  (item.Status === _ctx.DiscountOfferStatus.PENDING_APPROVAL)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("div", _hoisted_13, [
                          _createElementVNode("button", {
                            hidden: "",
                            onClick: ($event: any) => (_ctx.rejectOffer(item.Id)),
                            class: "btn btn-danger float-end me-4"
                          }, " Reject All Options ", 8, _hoisted_14)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.InvoiceDiscountOfferOptions, (option, optIndex) => {
                    return (_openBlock(), _createElementBlock("div", { key: optIndex }, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", _hoisted_16, [
                          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "text-gray-600" }, "Payment Date - ", -1)),
                          _cache[2] || (_cache[2] = _createTextVNode()),
                          _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.countSubmitedDate(option.PaymentPeriodInDays,item)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text-gray-600" }, "Discount Percent - ", -1)),
                          _cache[4] || (_cache[4] = _createTextVNode()),
                          _createElementVNode("span", _hoisted_19, _toDisplayString(option.DiscountPercent.toTwoFractionDigits()) + " %", 1)
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-gray-600" }, "New Total Amount - ", -1)),
                          _cache[6] || (_cache[6] = _createTextVNode()),
                          _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.countNewTotalAmount(option.DiscountPercent)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_22, [
                          (option.IsAccepted)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_23, "Accepted"))
                            : _createCommentVNode("", true)
                        ]),
                        (item.Status === _ctx.DiscountOfferStatus.PENDING_APPROVAL)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              (_ctx.canAcceptDate(option.PaymentPeriodInDays))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                    _createElementVNode("button", {
                                      onClick: ($event: any) => (_ctx.acceptOfferOption(item.Id, option.Id)),
                                      class: "btn btn-primary me-4 mt-0 float-end"
                                    }, " Accept ", 8, _hoisted_26)
                                  ]))
                                : (_openBlock(), _createElementBlock("div", _hoisted_27, [...(_cache[7] || (_cache[7] = [
                                    _createElementVNode("div", {
                                      class: "text-light-danger p-3 bg-danger me-4 float-end",
                                      style: {"border-radius":"5px"}
                                    }, " Expired ", -1)
                                  ]))]))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _cache[8] || (_cache[8] = _createElementVNode("hr", null, null, -1))
                    ]))
                  }), 128))
                ])
              ], 8, _hoisted_10)
            ]))
          }), 128))
        ]),
        (_ctx.invoice?.InvoiceDiscountOffers?.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [...(_cache[9] || (_cache[9] = [
              _createElementVNode("div", { class: "alert alert-danger p-5 text-center" }, [
                _createElementVNode("h4", { class: "mb-1 text-dark" }, "No Data")
              ], -1)
            ]))]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}